import { alpha } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  diffViewerContainer: {
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
  },
  added: {
    backgroundColor: alpha(theme.palette.success.light, 0.3),
  },
  removed: {
    backgroundColor: alpha(theme.palette.error.light, 0.3),
    textDecoration: 'line-through',
  },
}));

export default useStyles;
